export function getCookie(name: string): any {
    const cookie = document.cookie;

    const cookieArray = cookie.split(';');

    const foundCookie = cookieArray.find((cookie) => cookie.includes(name));

    return foundCookie?.split('=')?.[1] || null;
}